module.exports = __webpack_public_path__ + "img/activate-phone.0f743677.png";